define(function(require) {

	const tpl = require('./t_itv_lp_item.hbs');

	return Marionette.ItemView.extend({
		tagName: 'li',
		className: 'sites-row-wrapper',
		template: tpl,
		events: {
			'click @ui.siteItem': 'siteItemClicked',
		},
		ui: {
			siteItem: '.site-item'
		},
		modelEvents: {},
		initialize: function(options) {
			this.collection = options.collection;
			this.selectedSitesCollection = options.selectedSitesCollection;
		},
		siteItemClicked: function(e) {
			e.preventDefault();
			//remove the internalIcon
			this.model.unset('internalIcon');
			//add the clicked site in the selectedsites collection
			this.selectedSitesCollection.add(this.model.toJSON());
			//close modal
			this.triggerMethod('popup:close',{siteSelected:true});
			//do here when model has no spatial

		},
		templateHelpers: function() {
		}
	});
});